module.exports = __webpack_public_path__ + "img/comdex-small-light.78fd7676.svg";